/**
 * Video Overlays Module
 * 
 * @description
 * <p>Handes video overlays</p>
 * <p>On page load, adds click events to all .video-btn and .video-inline-btn elements (used in various pages)</p>
 * <p>Self-initializes when you include this module.</p>
 * 
 * @module videos
 *
 * @namespace site.videos
 */
( /* @lends module:videos */ function(site,$){
	"use strict";
(function($){
	var trace = {push: function() {}},
		dom = {};
		var currentVideoContainer = null;

	function init() {
		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};

		dom.site = $('#site');

		dom.videoBtn = $('.video-btn');
		dom.videoBtn.each(function(){
			$(this).on('click', function(event) {
				event.preventDefault();
				open($(this));
				site.lockScreen();
			});
		});	

		dom.videoInlineBtn = $('.video-inline-btn');
		dom.videoInlineBtn.each(function(){
			$(this).on('click', function(event) {
				event.preventDefault();
				replace($(this));
			});
		});	

		dom.videoFullScreen = $('.video-full-screen-change');
		dom.videoFullScreen.each(function(){
			$(this).on('click', function(event) {
				event.preventDefault();
				var galleryWrapper = $(this).closest(".impact-video-content-wrap");
      			var videoContainer = galleryWrapper.find(".video-full-screen-change");
				currentVideoContainer = videoContainer;
			});
		});	
		
		document.addEventListener("fullscreenchange", function () {
			
			if (currentVideoContainer) {
			  var galleryWrapper = currentVideoContainer.closest(
				".impact-video-content-wrap"
			  );
	  
			  if (galleryWrapper.length > 0) {
				var galleryWrapperId = galleryWrapper.attr("id");
				var element = document.getElementById(galleryWrapperId);
	  
				if (element) {
				  setTimeout(function () {
					element.scrollIntoView();
				  }, 100);
				}
			  }
			}
		});
	}


	function open(obj) {

		trace.push('open '+obj);

		var vidIframe = obj.attr('data-iframe-url');
		var vidYouTubeId = obj.attr('data-youtube-vidid');
		var vidVimeoId = obj.attr('data-vimeo-vidid');
		var vidTitle = obj.attr('data-vid-title');
		var vidDesc = obj.attr('data-vid-desc');
		var vidImg = obj.attr('data-vid-img');
		trace.push('vidIframe = '+vidIframe);
		var videoPlayer = "";

		if(vidIframe != undefined) {
			videoPlayer = '<iframe src="'+vidIframe+'" width="100%" height="100%" frameborder="0" seamless="seamless" allow="autoplay; fullscreen" allowfullscreen></iframe>';
		}

		if(vidYouTubeId != undefined) {
			videoPlayer = '<iframe src="https://www.youtube.com/embed/'+vidYouTubeId+'" width="100%" height="100%" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
		}
		if(vidVimeoId != undefined) {
			videoPlayer = '<iframe src="https://player.vimeo.com/video/'+vidVimeoId+'&form=html&autoplay=1&transparent=0" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
		}

		if(vidIframe != undefined) {
			var imagempx = '<img class="vid-popimg" src="'+ vidImg +'"/>';
			dom.site.append('<div id="video-overlay"><div class="holder"><div class="close-btn hoverable"></div><div class="vid-content">'+imagempx+videoPlayer+'</div><div class="desc-content"><h3 class="title">'+vidTitle+'</h3><p class="desc">'+vidDesc+'</p></div></div>');
		}
		else{
			dom.site.append('<div id="video-overlay"><div class="holder"><div class="close-btn hoverable"></div><div class="vid-content">'+videoPlayer+'</div><div class="desc-content"><h3 class="title">'+vidTitle+'</h3><p class="desc">'+vidDesc+'</p></div></div>');
		}
		dom.overlay = $('#video-overlay');
		dom.vidContent = dom.overlay.find('.vid-content');
		dom.descContent = dom.overlay.find('.desc-content');

		dom.closeBtn = dom.overlay.find('.close-btn');

		trace.push('[videos.js] content: ');
		trace.push(dom.vidContent);

		//site.cursor.registerNativeContainer(dom.vidContent);

		dom.closeBtn.on('click', function() {
			close();
			
		});

		dom.overlay.addClass('active');
		
		openContent();

	}

	function openContent() {
		trace.push('openContent');	
		dom.vidContent.addClass('active');
		dom.descContent.addClass('active');
	}


	function replace(obj) {
		trace.push('replace');	
		var vidIframe = obj.attr('data-iframe-url');
		var videoPlayer = '<iframe src="'+vidIframe+'" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen />';
		obj.addClass('active');
		obj.html(videoPlayer);
		
	}
	
	function close() {
		trace.push('close');
		site.unlockScreen();
		dom.overlay.removeClass('active');
		setTimeout(function(){ 
			remove();
			site.cursor.$cursor.removeClass('hide');
		}, 300);
	}

	function remove() {
		trace.push('remove');	
		dom.overlay.remove();
	}

	// Public API definitions
	site.videos = {
	};


	$(function(){
		init();
		$( document ).ajaxComplete(function(event, xhr, options) {
          if (options.url.toLowerCase().indexOf("api/newsroom/node") >= 0 || options.url.toLowerCase().indexOf("api/newsroom/list") >= 0) {
                init();
            }
        });
	});
	})(jQuery);
})(window.site=window.site || {}, jQuery);
